import React, { useState } from "react";
import { X } from "lucide-react";

export default function AnnouncementBar() {
  const [open, setOpen] = useState(true);
  if (!open) return null;
  return (
    <div className="bg-[#F7941D] text-white text-xs sm:text-sm font-semibold relative" data-testid="announcement-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 pr-12 text-center">
        🎉 First Order 10% OFF — Code: <span className="bg-white text-[#F7941D] px-2 py-0.5 rounded font-bold mx-1">FIRST10</span> | Valid this week only!
      </div>
      <button
        onClick={() => setOpen(false)}
        data-testid="announcement-close"
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded hover:bg-white/15 transition"
        aria-label="Close announcement"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
